module.exports = __webpack_public_path__ + "img/lesser_water_elemental_small.58cd1075.png";